const liquorList = [
  {
    type: "Vodka",
    list: [
      {
        name: "Barton (Well)",
        price: "$4.50",
      },
      {
        name: "Absolute",
        price: "$6.25",
      },
      {
        name: "Stolichnya",
        price: "$5.75",
      },
      {
        name: "Grey Goose",
        price: "$7.25",
      },
      {
        name: "Kettle One",
        price: "$6.75",
      },
      {
        name: "Whipped",
        price: "$5.25",
      },
      {
        name: "Grape",
        price: "$5.25",
      },
      {
        name: `Tito's`,
        price: "$6.25",
      },
      {
        name: "Vanilla",
        price: "$5.25",
      },
    ],
  },
  {
    type: "Bourbon / Whiskey",
    list: [
      {
        name: "Dickel",
        price: "$5.75",
      },
      {
        name: "Evan Will (Well)",
        price: "$4.50",
      },
      {
        name: "Crown",
        price: "$6.25",
      },
      {
        name: "Jack Daniel",
        price: "$5.75",
      },
      {
        name: "Knob Creek",
        price: "$7.75",
      },
      {
        name: "Makers Mark",
        price: "$6.25",
      },
      {
        name: `Beam Devil's Cut`,
        price: "$6.75",
      },
      {
        name: `Beam Rye`,
        price: "$5.75",
      },
      {
        name: `Jim Beam`,
        price: "$5.75",
      },
      {
        name: `Wild Turkey 101`,
        price: "$6.25",
      },
      {
        name: `Seagrams 7`,
        price: "$5.25",
      },
      {
        name: `Can Club`,
        price: "$5.25",
      },
      {
        name: `Bushmills`,
        price: "$6.75",
      },
      {
        name: `Jameson Black Bar`,
        price: "$7.25",
      },
      {
        name: `Jamesons`,
        price: "$6.25",
      },
      {
        name: `Gentleman Jack`,
        price: "$6.75",
      },
      {
        name: `Woodford Reserve`,
        price: "$7.75",
      },
      {
        name: `Fireball`,
        price: "$5.25",
      },
      {
        name: `J. Beam Fired`,
        price: "$5.75",
      },
      {
        name: `Bullet`,
        price: "$6.25",
      },
      {
        name: `Jack Honey`,
        price: "$5.75",
      },
      {
        name: `Turk Honey`,
        price: "$5.75",
      },
      {
        name: `Basil Hayden`,
        price: "$7.75",
      },
      {
        name: `Bookers`,
        price: "$8.75",
      },
    ],
  },
  {
    type: "Gin",
    list: [
      {
        name: "Barton (Well)",
        price: "$4.50",
      },
      {
        name: "Tanqueray",
        price: "$6.25",
      },
      {
        name: "Bombay",
        price: "$6.75",
      },
      {
        name: "Jendricks",
        price: "$7.75",
      },
    ],
  },
  {
    type: "Rum",
    list: [
      {
        name: "Barton (Well)",
        price: "$4.50",
      },
      {
        name: "Bacardi",
        price: "$5.25",
      },
      {
        name: "Malibu",
        price: "$5.75",
      },
      {
        name: "Capt Morgan",
        price: "$5.75",
      },
      {
        name: "Myers",
        price: "$5.75",
      },
      {
        name: "Bacardi 151",
        price: "$5.75",
      },
    ],
  },
  {
    type: "Tequila",
    list: [
      {
        name: "Montezuma (Well)",
        price: "$4.50",
      },
      {
        name: "Jose Cuervo",
        price: "$5.75",
      },
      {
        name: "Patron",
        price: "$7.75",
      },
      {
        name: "Don Julio",
        price: "$8.25",
      },
    ],
  },
  {
    type: "Scotch",
    list: [
      {
        name: "Clan Mcgregor (Well)",
        price: "$4.50",
      },
      {
        name: "Dewars",
        price: "$6.75",
      },
      {
        name: "Glenlivet",
        price: "$7.75",
      },
      {
        name: "Macallan 12",
        price: "$7.75",
      },
    ],
  },
  {
    type: "Other",
    list: [
      {
        name: "Jager",
        price: "$6.75",
      },
      {
        name: "Ice 101",
        price: "$6.75",
      },
      {
        name: "Jager Bomb",
        price: "$7.75",
      },
      {
        name: "Couvoisier",
        price: "$7.75",
      },
      {
        name: "B&B",
        price: "$7.75",
      },
      {
        name: "Baileys",
        price: "$6.25",
      },
      {
        name: "Amaretto",
        price: "$6.25",
      },
      {
        name: "Southern Comfort",
        price: "$6.25",
      },
    ],
  },
  {
    type: "Drinks",
    list: [
      {
        name: "Margarita (Well)",
        price: "$5.75",
      },
      {
        name: "Margarita Top Shelf",
        price: "$6.75",
      },
      {
        name: "Long Island Ice Tea",
        price: "$6.25",
      },
      {
        name: "Bloody Mary",
        price: "$5.25",
      },
      {
        name: "Cosmo",
        price: "$6.25",
      },
      {
        name: "Martini (Well)",
        price: "$6.25",
      },
      {
        name: "White Russian",
        price: "$5.75",
      },
      {
        name: "Red Head Slut",
        price: "$7.25",
      },
      {
        name: "Lemon Drop",
        price: "$5.25",
      },
      {
        name: "Fuzzy Navel",
        price: "$5.25",
      },
      {
        name: "Amaretto Sour",
        price: "$5.25",
      },
      {
        name: "Car Bomb",
        price: "$8.25",
      },
      {
        name: "Sex on the Beach",
        price: "$5.75",
      },
      {
        name: "Ginger Mixer",
        price: "$1.00 Up Charge",
      },
    ],
  },
];

export default liquorList;



// WEBPACK FOOTER //
// ./src/services/drinkLists/liquorList.js